export default __webpack_public_path__ + "static/media/faizanimg.5728ded3.png";